import {
    HeroSectionClientes,
    BeneficiosClientesSection,
    PlanosClientesSection,
    ComoComecarSection,
    DepoimentosSection,
    ComeceAgoraSection
} from '../components/Clientes'
import '../styles/clientes.css'

export function ClientesPage() {
    return (
        <div className="clients-page">
            <HeroSectionClientes />
            <BeneficiosClientesSection />
            <PlanosClientesSection />
            <ComoComecarSection />
            <DepoimentosSection />
            <ComeceAgoraSection />
        </div>
    )
}
